import { OID_MAP } from "@/utils/constants/constants.track";

export const ProductServicesData = [
  {
    id: "1",
    name: "商机服务",
    describe:
      '<span class="bold">2.2亿</span> 招投标信息积累，每天 <span class="bold">25万+ </span>招投标资讯更新，微信、浏览器、APP，全平台服务支持',
  },
  {
    id: "2",
    name: "标讯发布",
    describe: '专注招投标信息服务 ，众多 <span class="bold">500强</span>企业信赖的招投标资讯平台',
  },
  { id: "3", name: "更多服务", describe: "拓展企业人脉，赢得更多商机，更有多种定制化服务等您垂询" },
];
export const ProductsServicesChildData = {
  1: [
    {
      id: "1-1",
      icon: require("@/assets/img/Login/LoginHeader/products-services-content/ProductsServices1_1.png"),
      name: "招标查询",
      describe: "查预告 查招标 查中标",
      oid: OID_MAP.PRODUCTS_SERVICES_BILLBOARD_CLICK,
    },
    {
      id: "1-2",
      icon: require("@/assets/img/Login/LoginHeader/products-services-content/ProductsServices1_2.png"),
      name: "VIP独家信息",
      describe: "千里马独家项目信息",
      oid: OID_MAP.PRODUCTS_SERVICES_VIP_CLICK,
    },
    {
      id: "1-3",
      icon: require("@/assets/img/Login/LoginHeader/products-services-content/ProductsServices1_3.png"),
      name: "拟在建项目查询",
      describe: "正在报批、立项中的项目",
      oid: OID_MAP.PRODUCTS_SERVICES_PROJECT_CLICK,
    },
    {
      id: "1-4",
      icon: require("@/assets/img/Login/LoginHeader/products-services-content/ProductsServices1_4.png"),
      name: "商机推送",
      describe: "微信、邮件实时接收最新动态",
      oid: OID_MAP.PRODUCTS_SERVICES_BUSINESS_OPPORTUNITY_PUSH_CLICK,
    },
    {
      id: "1-5",
      icon: require("@/assets/img/Login/LoginHeader/products-services-content/ProductsServices1_5.png"),
      name: "企业智能管理",
      describe: "业务统一管理、商机自动分配",
      oid: OID_MAP.PRODUCTS_SERVICES_ENTERPRISE_INTELLIGENT_MANAGEMENT_CLICK,
    },
    {
      id: "1-6",
      icon: require("@/assets/img/Login/LoginHeader/products-services-content/ProductsServices1_6.png"),
      name: "企业商情分析",
      describe: "潜在客户、竞争对手历史数据分析",
      oid: OID_MAP.PRODUCTS_SERVICES_COMPANY_ANALYSE_RIGHT_CLICK,
    },
  ],
  2: [
    {
      id: "2-1",
      icon: require("@/assets/img/Login/LoginHeader/products-services-content/ProductsServices2_1.png"),
      name: "发布招标信息",
      describe: "发布招标、采购信息",
      oid: OID_MAP.PRODUCTS_SERVICES_PUBLISH_BIDDING_CLICK,
    },
    {
      id: "2-2",
      icon: require("@/assets/img/Login/LoginHeader/products-services-content/ProductsServices2_2.png"),
      name: "推荐招标专区",
      describe: "专属招标专区，提升信息曝光量",
      oid: OID_MAP.PRODUCTS_SERVICES_RECOMMEND_BIDDING_CLICK,
    },
  ],
  3: [
    {
      id: "3-1",
      icon: require("@/assets/img/Login/LoginHeader/products-services-content/ProductsServices3_1.png"),
      name: "找人脉",
      describe: "专业团队精确定位项目联系人",
      oid: OID_MAP.PRODUCTS_SERVICES_FINDING_CONNECTIONS_CLICK,
    },
    {
      id: "3-2",
      icon: require("@/assets/img/Login/LoginHeader/products-services-content/ProductsServices3_2.png"),
      name: "拓客宝",
      describe: "定位优质潜客资源",
      oid: OID_MAP.PRODUCTS_SERVICES_TUO_KE_BAO_CLICK,
    },
    {
      id: "3-3",
      icon: require("@/assets/img/Login/LoginHeader/products-services-content/ProductsServices3_3.png"),
      name: "人脉通",
      describe: "拓展您的人脉资源",
      oid: OID_MAP.PRODUCTS_SERVICES_REN_MAI_TONG_CLICK,
    },
    {
      id: "3-4",
      icon: require("@/assets/img/Login/LoginHeader/products-services-content/ProductsServices3_4.png"),
      name: "渠道宝",
      describe: "AI大数据帮您高效拓展渠道",
      oid: OID_MAP.PRODUCTS_SERVICES_QU_DAO_BAO_CLICK,
    },
    {
      id: "3-5",
      icon: require("@/assets/img/Login/LoginHeader/products-services-content/ProductsServices3_5.png"),
      name: "数据商城",
      describe: "分行业商机分析、供应商筛选",
      oid: OID_MAP.PRODUCTS_SERVICES_DATA_MALL_CLICK,
    },
    {
      id: "3-6",
      icon: require("@/assets/img/Login/LoginHeader/products-services-content/ProductsServices3_6.png"),
      name: "数据定制",
      describe: "数据维度定制、BI、API定制等",
      oid: OID_MAP.PRODUCTS_SERVICES_DATA_CUSTOMIZED_CLICK,
    },
  ],
};
